import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import UserSearch from './component';

class UserSearchContainer extends Component {
  constructor() {
    super();
    this.state = {
      search: null,
      resultMessage: '',
      users: {
        list: [],
        loading: false
      }
    };
  }

  onChangeOfUserSearch = (e, data) => {
    const search = data.value;
    this.setState({ search });
  };

  onClickOfSearch = (e) => {
    const dataSet = e.target.dataset;
    if (!(dataSet.actiontype === 'onClickOfSearch' || e.keyCode === 13)) {
      return false;
    }
    const value = this.state.search;

    if (!value) {
      return this.setState((prevState, props) => {
        return {
          users: {
            list: [],
            loading: false
          }
        };
      });
    }
    this.setState((prevState, props) => {
      return {
        users: {
          list: [],
          loading: true
        }
      };
    });
    this.props.getDataFromAPI(
      `/users/search?search=${value}`,
      'GET',
      undefined,
      response => {          
        this.setState((prevState, props) => {
          const resultMessage = `${response.length} user${response.length>=2?'s':''} found.`;
          return {
            resultMessage,
            users: {
              list: response,
              loading: false
            }
          };
        });
      },
      err => {
        this.setState((prevState, props) => {
          return {
            users: {
              list: [],
              loading: false
            }
          };
        });
        toastr.error('ERROR', err.message);
        console.log(err);
      }
    );
  };

  onClickOfDelete = (name, userId) => {
    if (!confirm(`Are you sure you want to delete "${name}"`)) {
      return;
    }
    // this.props.setLoading(true);

    if (!userId) {
      this.props.setLoading(false);
      return toastr.warning('Invalid', 'Invalid User Id');
    }

    this.props.getDataFromAPI(
      '/users',
      'DELETE',
      { userIdColl: [userId] },
      response => {
        const newUsers= this.state.users.list.filter(el => el.id !== userId );
        this.setState(prev => ({
            users: {
                list: newUsers,
              }
        }));  
        toastr.success('Successful', 'Deleted the user');
      },
      err => {
        this.setState(prev => ({
            users: {
                list:[],
              }
        }));
        toastr.error('Failed', 'Delete user operation failed');
      }
    );
  };



  render() {
    // console.log('userDetails ----------> ', this.state.users);
    
    return (
      <UserSearch
        users={this.state.users}
        resultMessage={this.state.resultMessage}
        onSearchChange={this.onChangeOfUserSearch}
        onClickOfSearch={this.onClickOfSearch}
        onClickOfDelete={this.onClickOfDelete}
      />
    );
  }
}

export default connect(null, { getDataFromAPI })(UserSearchContainer);



// WEBPACK FOOTER //
// ./src/Modules/UserSearch/container.jsx